import { useCallback, useEffect, useState } from "react";
import {
  DesignTokens,
  Row,
  Col,
  Button,
  RangePicker,
  UndoIcon,
} from "melco-ui";

//import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isEmpty, some } from "lodash-es";

import { ProductsFilter } from "./filter/ProductsFilter";
import { ReportsDownloadListFiltersType } from "../../hooks/reports/reportsListFilterType";
import dayjs from "dayjs";
import styled from "styled-components";
import { AllUserReportsDownloadButton } from "./AllUserReportsDownloadButton";

const { spacings } = DesignTokens;

type ReportsDownloadListFilterProps = {
  onFiltersChange: (
    filters: ReportsDownloadListFiltersType | undefined
  ) => void;
};

export const ReportsDownloadListFilter: React.FC<
  ReportsDownloadListFilterProps
> = ({ onFiltersChange }) => {
  const ResetButtonWrapper = styled.div`
    margin-left: 15px;
  `;
  const { t } = useTranslation();

  const [reportsFilter, setReportsFilter] = useState<
    ReportsDownloadListFiltersType | undefined
  >({
    startTimeStamp: dayjs().startOf("month").toDate(),
    endTimeStamp: dayjs().endOf("day").toDate(),
  });

  const [searchValue, setSearchValue] = useState("");

  const resetFilter = useCallback(() => {
    setSearchValue("");
    setReportsFilter({
      startTimeStamp: dayjs().startOf("month").toDate(),
      endTimeStamp: dayjs().endOf("day").toDate(),
    });
  }, []);

  const [selectedProductValue, setSelectedProductValue] = useState("");

  // const allLevelSubscription = useLevelSubscriptionData(ReportsFilter?.Products);
  useEffect(() => {
    console.log({ reportsFilter });
    onFiltersChange(reportsFilter);
  }, [reportsFilter, onFiltersChange]);

  return (
    <div>
      <Row gutter={[spacings.middle, spacings.middle]}>
        <Col flex={1}>
          <ProductsFilter
            onChange={(value) => {
              setSelectedProductValue(value);
              setReportsFilter((prevFilter) => {
                console.log({ value, prevFilter });
                return {
                  ...prevFilter,
                  Products: !isEmpty(value) ? value : undefined,
                };
              });
            }}
            value={reportsFilter?.Products}
          />
        </Col>
        <Col flex={1}>
          <RangePicker
            format={"L"}
            onChange={(value) => {
              const startTimeStamp =
                (value && value[0] && value[0].startOf("day").toDate()) ??
                undefined;
              const endTimeStamp =
                (value && value[1] && value[1].endOf("day").toDate()) ??
                undefined;

              setReportsFilter((prevFilter) => {
                return {
                  ...prevFilter,
                  startTimeStamp,
                  endTimeStamp,
                };
              });
            }}
            value={
              reportsFilter?.startTimeStamp &&
              reportsFilter?.endTimeStamp && [
                dayjs(reportsFilter?.startTimeStamp),
                dayjs(reportsFilter?.endTimeStamp),
              ]
            }
            placeholder={[
              t("orders_list.filter.start_timestamp.placeholder"),
              t("orders_list.filter.end_timestamp.placeholder"),
            ]}
          />
        </Col>

        <Col flex={1}>
          <Row>
            <AllUserReportsDownloadButton
              filename={
                (selectedProductValue ? selectedProductValue : "All") +
                "_Billing " +
                reportsFilter?.startTimeStamp?.toLocaleDateString() +
                " - " +
                reportsFilter?.endTimeStamp?.toLocaleDateString()
              }
              dateRange={{
                start: dayjs(reportsFilter?.startTimeStamp),
                end: dayjs(reportsFilter?.endTimeStamp),
              }}
              disabled={
                reportsFilter?.startTimeStamp == undefined ||
                reportsFilter.endTimeStamp == undefined
              }
              productCode={selectedProductValue}
            />
            {/* </Col>  */}

            <Col xs={6} md={5} xl={3}>
              {some(reportsFilter) && (
                <ResetButtonWrapper>
                  <Button
                    icon={<UndoIcon />}
                    type="primary"
                    onClick={resetFilter}
                    data-cy-id="licenses-filter-reset"
                    style={{ minWidth: "100%" }}
                  >
                    {t("filter.reset.button", { ns: "melco-common" })}
                  </Button>
                </ResetButtonWrapper>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
